import { useState } from 'react';
import { events } from '@/mocks/gossip';

const footerLinks = [
  { label: '今日热榜', href: '#hot' },
  { label: '吃瓜时间线', href: '#timeline' },
  { label: '事件盘点', href: '#events' },
  { label: '年度汇总', href: '#annual' },
  { label: '大事件回顾', href: '#major' },
  { label: '翻车合集', href: '#flip' },
  { label: '常见问题', href: '#faq' },
];

const categories = Array.from(new Set(events.map((e) => e.category))).slice(0, 6);

export default function Footer() {
  const [status, setStatus] = useState<{ type: 'idle' | 'ok' | 'err'; msg: string }>({ type: 'idle', msg: '' });
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const fd = new FormData(form);
    const honeypot = String(fd.get('website_alt') || '').trim();
    const body = new URLSearchParams();
    fd.forEach((v, k) => {
      if (k !== 'website_alt') body.append(k, String(v));
    });

    const fakeSuccess = () => {
      setStatus({ type: 'ok', msg: '订阅成功，最新盘点会第一时间送到你的邮箱。' });
      form.reset();
      setBusy(false);
    };

    if (honeypot) {
      fakeSuccess();
      return;
    }

    setBusy(true);
    try {
      const res = await fetch('https://readdy.ai/api/form/dafto9jep053ijub1v80', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      const text = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string } } = {};
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = {};
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.meta?.detail || text;
      const ok = res.ok && parsed?.code === 'OK' && !/spam/i.test(text);
      if (ok) {
        fakeSuccess();
      } else {
        setStatus({
          type: 'err',
          msg: typeof serverMsg === 'string' && serverMsg ? serverMsg : '订阅失败，请稍后再试。',
        });
        setBusy(false);
      }
    } catch {
      setStatus({ type: 'err', msg: '网络异常，请稍后再试。' });
      setBusy(false);
    }
  };

  return (
    <footer id="footer" className="bg-background-100/70 border-t border-background-200">
      {/* 订阅 CTA */}
      <div className="border-b border-background-200">
        <div className="container-site py-10 md:py-12 flex flex-col lg:flex-row lg:items-center gap-6 justify-between">
          <div className="max-w-md">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">订阅吃瓜黑料，热点不再错过</h2>
            <p className="mt-2 text-foreground-600 text-sm leading-relaxed">每周把最值得吃的大瓜、时间线与年度盘点整理成邮件送给你。</p>
          </div>
          <form data-readdy-form onSubmit={handleSubmit} className="w-full lg:max-w-md">
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-0 sm:items-center">
              <div className="relative flex-1">
                <i className="ri-mail-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱地址"
                  className="w-full h-12 pl-11 pr-4 rounded-lg sm:rounded-l-full sm:rounded-r-none bg-background-50 border border-background-200 text-sm outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/50"
                />
              </div>
              <button
                type="submit"
                disabled={busy}
                className="inline-flex items-center justify-center h-12 px-6 rounded-lg sm:rounded-r-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 disabled:opacity-60 transition whitespace-nowrap"
              >
                {busy ? '提交中…' : '立即订阅'}
              </button>
            </div>
            {/* 反垃圾蜜罐 */}
            <div className="trap-stash" aria-hidden="true">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" readOnly />
            </div>
            <div className="mt-3">
              {status.type === 'ok' && <p className="text-sm text-primary-600 flex items-center gap-1.5"><i className="ri-checkbox-circle-line"></i>{status.msg}</p>}
              {status.type === 'err' && <p className="text-sm text-primary-600 flex items-center gap-1.5"><i className="ri-close-circle-line"></i>{status.msg}</p>}
            </div>
          </form>
        </div>
      </div>

      {/* 主内容 */}
      <div className="container-site py-10 md:py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-fire-fill"></i>
            </span>
            <span className="font-heading text-lg text-primary-700">吃瓜黑料</span>
          </div>
          <p className="text-sm text-foreground-600 leading-relaxed">
            专注娱乐热点事件盘点、年度汇总与大事件回顾的信息整理平台，帮你按时间线快速摸清来龙去脉。
          </p>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900 mb-4">快捷导航</h3>
          <ul className="space-y-2.5">
            {footerLinks.slice(0, 4).map((l) => (
              <li key={l.href}><a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900 mb-4">更多内容</h3>
          <ul className="space-y-2.5">
            {footerLinks.slice(4).map((l) => (
              <li key={l.href}><a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition">{l.label}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold text-foreground-900 mb-4">热门栏目</h3>
          <ul className="space-y-2.5 flex flex-wrap gap-x-3">
            {categories.map((c) => (
              <li key={c}><a href="#events" className="text-sm text-foreground-600 hover:text-primary-600 transition">{c}</a></li>
            ))}
          </ul>
          <div className="mt-5 flex items-center gap-3">
            <a href="#top" aria-label="回到顶部" className="w-9 h-9 rounded-full border border-background-300 text-foreground-600 flex items-center justify-center hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition">
              <i className="ri-arrow-up-line"></i>
            </a>
            <a href="mailto:hello@chigua.example" className="text-sm text-foreground-600 hover:text-primary-600 transition whitespace-nowrap" rel="nofollow">
              hello@chigua.example
            </a>
          </div>
        </div>
      </div>

      {/* 版权条 */}
      <div className="border-t border-background-200">
        <div className="container-site py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 吃瓜黑料 · 内容整理仅供参考，文中人物与事件均为示例，不构成任何评价。</p>
          <div className="flex items-center gap-4">
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600">内容原则</a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600">勘误申请</a>
            <a href="#top" className="text-xs text-foreground-500 hover:text-primary-600">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}